// extracted by mini-css-extract-plugin
export var buttonsWrapper = "styles-module--buttonsWrapper--f285e";
export var wrapper = "styles-module--wrapper--ffd37";